import { Grid, TextField, Button, Typography, Grow } from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../app/hooks";
import {
  selectCalculatorState,
  setCommunicationData,
  setOutlaysInnerAllowNextStep,
  setActiveOutlaysInnerStep,
  setTotal,
  setTotoalCommunication,
  setActiveStep,
} from "../../../../../../calculatorSlice";
import { ICommunicationData } from "../../../../../../../../lib/interfaces/IFixedOutlay";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import sum from "../../../../../../../../lib/utils/sum";
import { NumberFormatCustom } from "../../../../../FormattedInputs";
import ArrowLeft from "../../../../../../assets/arrow-left.svg";
import ArrowRight from "../../../../../../assets/arrow-right.svg";
import { CustomTextFiled } from "../../../../../CustomTextFiled";

function CommunicationForm() {
  const dispatch = useAppDispatch();
  const CalculatorState = useAppSelector(selectCalculatorState);
  const { communicationData } = useAppSelector(selectCalculatorState);
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<ICommunicationData>({
    defaultValues: communicationData,
  });

  const onSubmit: SubmitHandler<ICommunicationData> = (data) => {
    delete data.communicationTotal;
    const sumWithInitialValue = sum(data);
    dispatch(setCommunicationData(data));
    dispatch(setTotoalCommunication(sumWithInitialValue));
    dispatch(setTotal());
    dispatch(setOutlaysInnerAllowNextStep(3));
    dispatch(setActiveOutlaysInnerStep(3));
  };
  const handleBackClick = () => {
    if (CalculatorState.allowedSteps > 0) {
      if (
        CalculatorState.outlaysInnerAllowedSteps >= 0 &&
        CalculatorState.outlaysInnerActiveStep === 0
      ) {
        dispatch(setActiveStep(0));
      }
      if (
        CalculatorState.outlaysInnerAllowedSteps > 0 &&
        CalculatorState.outlaysInnerActiveStep > 0
      ) {
        dispatch(
          setActiveOutlaysInnerStep(CalculatorState.outlaysInnerActiveStep - 1)
        );
      }
    }
  };
  return (
    <Grid
      sx={{ textAlign: "center", display: "grid", placeItems: "center" }}
      container
    >
      <Grid item>
        <br />
        <Grow timeout={{ enter: 900, exit: 100 }} in={true}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <h3
                style={{
                  textAlign: "center",
                  fontWeight: "700",
                  width: "100%",
                  fontSize: "1.75rem",

                  padding: 0,
                }}
              >
                תקשורת
              </h3>
            </div>
            <br />
            <Controller
              name="cellphone"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  error={!!errors.cellphone}
                  helperText={errors.cellphone && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label="הוצאות טלפון נייד"
                  variant="filled"
                />
              )}
            />
            <Controller
              name="cellphoneSubscribers"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  error={!!errors.cellphone}
                  helperText={errors.cellphone && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label=" מנויים כמו נטפליקס/ספוטיפיי"
                  variant="filled"
                />
              )}
            />

            <br />
            <div
              style={{
                display: "grid",
                placeItems: "center",
                alignItems: "center",
              }}
            >
              <br />
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  alignItems: "center",
                  gridTemplateColumns: "auto auto",
                  alignContent: "center",
                  justifyContent: "center",
                  gap: "1rem",
                }}
              >
                <button onClick={handleBackClick} className="back">
                  <img
                    src={ArrowRight}
                    alt="arrow"
                    style={{ marginBottom: "0.25rem" }}
                  />
                  <Typography
                    sx={{ fontSize: "1.2rem", color: "black" }}
                    display="block"
                    gutterBottom
                  >
                    הקודם
                  </Typography>
                </button>
                <button className="btn next" type="submit">
                  <Typography
                    sx={{ fontSize: "1.2rem" }}
                    display="block"
                    gutterBottom
                  >
                    הבא
                  </Typography>
                  <img
                    src={ArrowLeft}
                    alt="arrow"
                    style={{ marginBottom: "0.25rem" }}
                  />
                </button>
              </div>
            </div>
          </form>
        </Grow>
        <br />
      </Grid>
    </Grid>
  );
}

export default CommunicationForm;
